var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEt = function SvgIconEt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 12c0 1.468.264 2.874.746 4.174L12 17.218l11.254-1.044c.482-1.3.746-2.706.746-4.174 0-1.448-.256-2.835-.726-4.12L12 6.783.726 7.88A12 12 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c5.16 0 9.558-3.256 11.253-7.826H.746C2.442 20.744 6.84 24 12 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 0C6.84 0 2.442 3.256.746 7.826h22.507C21.558 3.256 17.16 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 17.74A5.74 5.74 0 1 0 12 6.26a5.74 5.74 0 0 0 0 11.479"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.999 7.556 1.036 3.189h3.358l-2.718 1.97 1.044 3.199-2.72-1.98-2.716 1.976 1.04-3.194-2.716-1.971h3.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.13 12.794-3.286-1.068 2.031-2.796-.844-.613L12 11.113 9.969 8.317l-.844.613 2.03 2.796-3.286 1.068.323.992 3.286-1.067v3.455h1.044V12.72l3.286 1.067z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconEt;